export const fetchHtml = async (url: string): Promise<string> => {
  if (!url) return '';

  try {
    const response = await fetch(url);

    if (!response.ok) {
      // eslint-disable-next-line no-console
      console.error(
        `Failed to fetch HTML from ${url}. Status: ${response.status}`,
      );

      return '';
    }

    return await response.text();
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(`Failed to fetch HTML from ${url}`, error);

    return '';
  }
};

export const LoadInlineScript = (script: string): void => {
  const inlineScript = document.createElement('script');

  inlineScript.defer = true;
  inlineScript.appendChild(document.createTextNode(script));

  document.head.appendChild(inlineScript);
};

export const LoadExternalScript = (
  url: string,
): Promise<void> => new Promise((resolve, reject) => {
  const externalScript = document.createElement('script');

  externalScript.type = 'text/javascript';
  externalScript.src = url;
  externalScript.defer = true;

  externalScript.onload = () => resolve();
  externalScript.onerror = () => {
    reject(new Error(`Failed to load script: ${url}`));
  };

  document.head.appendChild(externalScript);
});

export const LoadExternalStyle = (
  url: string,
  onload: ((this: GlobalEventHandlers, ev: Event) => any) | null,
): void => {
  const externalStyle = document.createElement('link');

  externalStyle.rel = 'stylesheet';
  externalStyle.href = url;
  externalStyle.onload = onload;

  document.head.appendChild(externalStyle);
};
